export enum CreateTestDesignTabEnum {
  STANDARD_TEMPLATES = "Standard Templates",
  SAVED_TEMPLATES = "Saved Templates",
  TEST_DESIGNER = "Test Designer",
}

export enum TestDesignerStepsEnum {
  BASIC_INFORMATION = "Basic Information",
  TEST_CONTENT = "Content",
  TEST_SECTIONS = "Test Sections",
  TEST_DETAILS = "Additional Details",
}

export enum TestTagsEnum {
  QUIZ = 1,
  CHAPTER_TEST = 2,
  FORMATIVE_ASSESSMENT = 3,
  HALF_YEARLY = 4,
  FULL_SYLLABUS = 5,
  PAST_YEAR_PAPER = 6,
  TEST_SERIES = 7,
}

export enum QuestionSelectionEnum {
  AUTOMATIC = 1,
  MANUAL = 2,
}

export enum MarkingSchemesEnum {
  NO_PARTIAL_MARKS = 1,
  SIMPLE_PARTIAL_MARKS = 2,
}

export enum InstituteTestStatusEnum {
  DRAFT = 1,
  FINALIZED = 2,
  PUBLISHED = 3,
  EXPIRED = 4,
}

export enum QuestionPaperTemplateEnum {
  SINGLE_COLUMN = "QP_SINGLE_COL",
  DOUBLE_COLUMN = "QP_DOUBLE_COL",
}

export enum OmrTemplateEnum {
  NORMAL = "OMR_NORMAL",
  NORMAL_SUBJECTIVE = "OMR_NORMAL_SUBJ",
  DENSE = "OMR_DENSE",
}

export enum ReplacementQuestionTypeEnum {
  EASIER = "Easier",
  HARDER = "Harder",
  SIMILAR = "Similar",
}

export enum QuestionCategoryOptionsEnum {
  ALL = 1,
  TEST = 5,
  RECOMMENDED = 9,
  INSTITUTE = 10,
}
